import { authApi } from '../api/authApi'

export const resetPassword = async ({
  token,
  newPassword,
}: {
  token: string
  newPassword: string
}) => {
  try {
    const response = await authApi.resetPassword({
      token,
      newPassword,
    })
    return response.data
  } catch (error) {
    console.error('Error requesting password reset', error)
    throw error
  }
}
